// src/pages/MorangosPage.js
import React from 'react';
import useSEO from '../hooks/useSEO';

const MorangosPage = () => {
  useSEO();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Morangos em Fertirrigação</h1>
      <p>Página em desenvolvimento - Por favor aguarde.</p>
    </div>
  );
};

export default MorangosPage;
